module.exports = __webpack_public_path__ + "img/kitkitphoto4.e642ad13.jpg";